// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__kDSzg system_resetButton__MmRuN"};